class SizeGuideAccordion extends HTMLElement {
  constructor () {
    super()
    this.contentBlock = this.querySelectorAll(
      '.size-guide__accordion-item-trigger',
    )

    this.contentBlock.forEach((button) => {
      button.addEventListener('click', this.openAccordion.bind(this))
    })
  }

  openAccordion (event) {
    if (event.target.classList.contains('is-active')) {
      event.target.classList.remove('is-active')
    } else {
      this.disableContentBlocks()
      event.target.classList.toggle('is-active')
    }
  }

  disableContentBlocks () {
    this.contentBlock.forEach((button) => {
      button.classList.remove('is-active')
    })
  }
}

customElements.define('size-guide-accordion', SizeGuideAccordion)
